import React from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';
import { APP_STORE_URL } from '../constants/appStoreLinks';

const Download: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div id="download" className="section-cta" style={{ padding: '5rem 0' }}>
            <div className="padding-global">
                <div className="container-large">
                    <div style={{
                        borderRadius: '2rem',
                        padding: '4rem 3rem',
                        position: 'relative',
                        overflow: 'hidden',
                    }}>
                        <div style={{
                            position: 'absolute',
                            top: '-50px',
                            right: '-50px',
                            width: '200px',
                            height: '200px',
                            borderRadius: '50%',
                            background: 'rgba(255,255,255,0.06)',
                        }} />
                        <div style={{
                            position: 'absolute',
                            bottom: '-30px',
                            left: '-30px',
                            width: '150px',
                            height: '150px',
                            borderRadius: '50%',
                            background: 'rgba(255,255,255,0.04)',
                        }} />

                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '3rem',
                            flexWrap: 'wrap',
                            position: 'relative',
                            zIndex: 1,
                        }}>
                            {/* Left: Text + App Store Badge */}
                            <div style={{ flex: '1 1 400px', minWidth: '280px' }}>
                                <h2 className="heading-style-h2 text-color-black" style={{ marginBottom: '0.5rem' }}>
                                    {t('download.title')}
                                </h2>
                                <div className="line-color-white" style={{ width: '100%', height: '15px' }}></div>
                                <div className="padding-bottom padding-small"></div>
                                <p className="text-size-medium text-color-black" style={{ opacity: 0.9, maxWidth: '600px' }}>
                                    {t('download.description')}
                                </p>
                                <div className="padding-bottom padding-medium"></div>

                                {/* App Store Badge */}
                                <a
                                    href={APP_STORE_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ display: 'inline-block', transition: 'transform 0.2s ease' }}
                                    onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.05)')}
                                    onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
                                    aria-label="Download on the App Store"
                                >
                                    <svg
                                        viewBox="0 0 120 40"
                                        width="180"
                                        height="60"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <rect width="120" height="40" rx="6" fill="#000" />
                                        <rect x="0.5" y="0.5" width="119" height="39" rx="5.5" stroke="#A6A6A6" fill="none" strokeWidth="0.4" />
                                        <g fill="#fff">
                                            <path d="M24.769 20.301a4.947 4.947 0 0 1 2.356-4.151 5.066 5.066 0 0 0-3.99-2.158c-1.68-.176-3.308 1.005-4.164 1.005-.872 0-2.19-.988-3.608-.958a5.315 5.315 0 0 0-4.473 2.728c-1.934 3.348-.491 8.269 1.361 10.976.928 1.325 2.017 2.805 3.434 2.753 1.39-.057 1.91-.886 3.588-.886 1.664 0 2.156.886 3.596.852 1.482-.024 2.43-1.33 3.33-2.669a11.01 11.01 0 0 0 1.517-3.088 4.776 4.776 0 0 1-2.947-4.404zM22.037 12.211a4.872 4.872 0 0 0 1.115-3.491 4.957 4.957 0 0 0-3.208 1.66 4.636 4.636 0 0 0-1.144 3.361 4.099 4.099 0 0 0 3.237-1.53z" />
                                        </g>
                                        <g fill="#fff" style={{ fontFamily: 'SF Pro Text, Helvetica, Arial, sans-serif' }}>
                                            <text x="42.5" y="15" fontSize="5" letterSpacing="0.04em">Download on the</text>
                                            <text x="42.5" y="27" fontSize="11" fontWeight="600" letterSpacing="-0.01em">App Store</text>
                                        </g>
                                    </svg>
                                </a>

                                <p className="text-color-white" style={{ fontSize: '0.8rem', marginTop: '1rem', opacity: 0.6 }}>
                                    {t('download.iosOnly')}
                                </p>
                            </div>

                            {/* Right: QR Code */}
                            <div style={{
                                flex: '0 0 auto',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: '1rem',
                            }}>
                                <div style={{
                                    background: '#fff',
                                    borderRadius: '1rem',
                                    padding: '1rem',
                                    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
                                }}>
                                    <QRCodeSVG
                                        value={APP_STORE_URL}
                                        size={160}
                                        level="H"
                                        includeMargin={false}
                                        fgColor="#1a1a2e"
                                    />
                                </div>
                                <p className="text-color-white" style={{
                                    fontSize: '0.85rem',
                                    opacity: 0.8,
                                    textAlign: 'center',
                                }}>
                                    {t('download.scanQrCode')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Download;
